<template>
  <v-container v-if="this.user != ''">

    <v-card outlined class="py-12">
      <v-slider
        v-model="week"
        label="Week"
        max="48"
        min="1"
        thumb-label="always"
        @change="loadGrid()"
      ></v-slider>
      <v-autocomplete
        v-model="species"
        :items="cn"
        @change="loadGrid()"
      ></v-autocomplete>

      <v-img height="100%" width="100%">
        {{ this.searchID }}
        <l-map
          :center="[30, -40]"
          style="height: 600px; width: 100%"
          :zoomControl="false"
          :zoom="2"
        >
          <l-tile-layer :url="urlStates" :attribution="attributionSummary" />
          <l-circle
            v-for="item in latlon"
            :key="item.id"
            :lat-lng="[item.lat, item.lon]"
            :radius="400"
            color="#A9A9A9"
          >
          </l-circle>
          <l-circle
            v-for="item2 in hitNotInGrid"
            :key="item2.id"
            :lat-lng="[item2.latitude, item2.longitude]"
            :radius="200"
            color="#F4BB44"
          >
          </l-circle>
          <l-circle
            v-for="(item3, i) in currentWeekNotInGrid"
            :key="i"
            :lat-lng="[item3[0].latitude, item3[0].longitude]"
            :radius="800"
            color="#FF0703"
          >
          </l-circle> </l-map
      ></v-img>
    </v-card>
    <!-- <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="6"
        md="6"
        lg="4"
        xl="3"
        v-for="(haikubox) in hitNotInGrid"
        :key="haikubox.id2"
      >
        <v-card dark class="py-2" variant="outlines">
          <v-card-title>{{ haikubox.serial }}</v-card-title>

          <l-map
            :center="[0, -40]"
            style="height: 300px; width: 100%"
            :scrollWheelZoom="false"
            :zoom="1"
          >
            <l-tile-layer :url="urlStates" :attribution="attributionSummary" />
            <l-circle
              :lat-lng="[haikubox.latitude, haikubox.longitude]"
              :radius="800"
              color="#FF0703"
            >
            </l-circle>
          </l-map>

          <Plotly
            :data="haikubox.spectrogram"
            :layout="plotlyLayout"
            :display-mode-bar="false"
          ></Plotly>
          <v-row>
            <v-col cols="8">
              <v-btn
                text
                v-if="isBat(haikubox)"
                :href="'https://www.batcon.org/about-bats/bats-101/'"
                target="_blank"
                color="light-blue"
                >BCI</v-btn
              ><v-btn
                text
                v-if="!isBat(haikubox)"
                :href="
                  haikubox.longitude > -30
                    ? 'https://ebird.org/species/' + haikubox.spCode
                    : 'https://www.allaboutbirds.org/guide/' +
                      replaceSpaces(haikubox.cn)
                "
                target="_blank"
                color="light-blue"
                >About</v-btn
              ><v-btn
                text
                v-if="!isBat(haikubox)"
                :href="'https://ebird.org/species/' + haikubox.spCode"
                target="_blank"
                color="light-blue"
                >eBird</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Unfiltered:
              {{ haikubox.detectionArrayUf }}
              {{ haikubox.detectionConfidenceUf }}
              <v-spacer></v-spacer>
              Filtered:
              {{ haikubox.detectionArrayF }}
              {{ haikubox.detectionConfidenceF }}
            </v-col> </v-row
          ><v-row>
            <v-col cols="1" class="mx-4">
              <v-btn
                icon
                @click="
                  playFile(
                    haikubox.wav,
                    haikubox.spCode,
                    haikubox.cn,
                    haikubox,
                    index,
                    true
                  )
                "
              >
                <v-icon left>mdi-play-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="10">
              <v-select
                class="mx-2"
                :items="haikubox.wavList"
                v-model="haikubox.currentWav"
                item-text="listname"
                item-value="filename"
                @change="
                  playFile(
                    haikubox.currentWav['filename'],
                    haikubox.spCode,
                    haikubox.cn,
                    haikubox,
                    index,
                    true
                  )
                "
                return-object
                single-line
              ></v-select> </v-col
          ></v-row>
        </v-card>
      </v-col>
    </v-row> -->
  </v-container>
</template>
  
<script>
import { API, Storage } from "aws-amplify";
import {
  getGridBySpCode,
  hitNotInGridBySpeciesByDate,
} from "../graphql/queries";
var moment = require("moment-timezone");
// import { Plotly } from "vue-plotly";
// https://github.com/chrisguttandin/standardized-audio-context
import { AudioContext, decodeAudioData } from "standardized-audio-context";
import { FFT } from "dsp.js";
var hann = [
  0.0, 3.77965773e-5, 1.51180595e-4, 3.4013491e-4, 6.04630957e-4, 9.44628746e-4,
  1.36007687e-3, 1.85091253e-3, 2.41706151e-3, 3.05843822e-3, 3.77494569e-3,
  4.56647559e-3, 5.43290826e-3, 6.3741127e-3, 7.38994662e-3, 8.48025644e-3,
  9.64487731e-3, 1.08836332e-2, 1.21963367e-2, 1.35827895e-2, 1.50427819e-2,
  1.65760932e-2, 1.81824916e-2, 1.98617342e-2, 2.16135671e-2, 2.34377255e-2,
  2.53339336e-2, 2.73019047e-2, 2.93413412e-2, 3.1451935e-2, 3.36333667e-2,
  3.58853068e-2, 3.82074146e-2, 4.05993391e-2, 4.30607187e-2, 4.55911813e-2,
  4.81903443e-2, 5.08578147e-2, 5.35931893e-2, 5.63960544e-2, 5.92659864e-2,
  6.22025514e-2, 6.52053053e-2, 6.82737943e-2, 7.14075543e-2, 7.46061116e-2,
  7.78689827e-2, 8.11956742e-2, 8.45856832e-2, 8.80384971e-2, 9.1553594e-2,
  9.51304424e-2, 9.87685015e-2, 1.02467221e-1, 1.06226043e-1, 1.10044397e-1,
  1.13921708e-1, 1.17857388e-1, 1.21850843e-1, 1.25901469e-1, 1.30008654e-1,
  1.34171776e-1, 1.38390206e-1, 1.42663307e-1, 1.46990432e-1, 1.51370928e-1,
  1.55804131e-1, 1.60289372e-1, 1.64825973e-1, 1.69413247e-1, 1.74050502e-1,
  1.78737036e-1, 1.8347214e-1, 1.88255099e-1, 1.9308519e-1, 1.97961681e-1,
  2.02883837e-1, 2.07850913e-1, 2.12862158e-1, 2.17916814e-1, 2.23014117e-1,
  2.28153297e-1, 2.33333576e-1, 2.38554171e-1, 2.43814294e-1, 2.49113148e-1,
  2.54449933e-1, 2.59823842e-1, 2.65234062e-1, 2.70679775e-1, 2.76160159e-1,
  2.81674384e-1, 2.87221617e-1, 2.92801019e-1, 2.98411747e-1, 3.04052952e-1,
  3.09723782e-1, 3.15423378e-1, 3.21150881e-1, 3.26905422e-1, 3.32686134e-1,
  3.38492141e-1, 3.44322565e-1, 3.50176526e-1, 3.56053138e-1, 3.61951513e-1,
  3.6787076e-1, 3.73809982e-1, 3.79768282e-1, 3.8574476e-1, 3.91738511e-1,
  3.97748631e-1, 4.03774209e-1, 4.09814335e-1, 4.15868096e-1, 4.21934577e-1,
  4.2801286e-1, 4.34102027e-1, 4.40201156e-1, 4.46309327e-1, 4.52425614e-1,
  4.58549094e-1, 4.64678841e-1, 4.70813928e-1, 4.76953428e-1, 4.83096412e-1,
  4.89241951e-1, 4.95389117e-1, 5.0153698e-1, 5.07684611e-1, 5.1383108e-1,
  5.19975458e-1, 5.26116815e-1, 5.32254225e-1, 5.38386758e-1, 5.44513487e-1,
  5.50633486e-1, 5.56745831e-1, 5.62849596e-1, 5.68943859e-1, 5.75027699e-1,
  5.81100196e-1, 5.87160431e-1, 5.93207489e-1, 5.99240456e-1, 6.05258418e-1,
  6.11260467e-1, 6.17245695e-1, 6.23213197e-1, 6.2916207e-1, 6.35091417e-1,
  6.41000339e-1, 6.46887944e-1, 6.52753341e-1, 6.58595644e-1, 6.6441397e-1,
  6.70207439e-1, 6.75975174e-1, 6.81716305e-1, 6.87429962e-1, 6.93115283e-1,
  6.98771407e-1, 7.0439748e-1, 7.09992651e-1, 7.15556073e-1, 7.21086907e-1,
  7.26584315e-1, 7.32047467e-1, 7.37475536e-1, 7.42867702e-1, 7.4822315e-1,
  7.5354107e-1, 7.58820659e-1, 7.64061117e-1, 7.69261652e-1, 7.74421479e-1,
  7.79539817e-1, 7.84615893e-1, 7.89648938e-1, 7.94638193e-1, 7.99582902e-1,
  8.04482319e-1, 8.09335702e-1, 8.14142317e-1, 8.18901439e-1, 8.23612347e-1,
  8.28274329e-1, 8.32886681e-1, 8.37448705e-1, 8.41959711e-1, 8.46419017e-1,
  8.5082595e-1, 8.55179843e-1, 8.59480037e-1, 8.63725883e-1, 8.67916738e-1,
  8.7205197e-1, 8.76130952e-1, 8.80153069e-1, 8.84117711e-1, 8.88024281e-1,
  8.91872186e-1, 8.95660845e-1, 8.99389686e-1, 9.03058145e-1, 9.06665667e-1,
  9.10211707e-1, 9.13695728e-1, 9.17117204e-1, 9.20475618e-1, 9.23770461e-1,
  9.27001237e-1, 9.30167455e-1, 9.33268638e-1, 9.36304317e-1, 9.39274033e-1,
  9.42177336e-1, 9.45013788e-1, 9.4778296e-1, 9.50484434e-1, 9.531178e-1,
  9.55682662e-1, 9.5817863e-1, 9.60605328e-1, 9.62962389e-1, 9.65249456e-1,
  9.67466184e-1, 9.69612237e-1, 9.71687291e-1, 9.73691033e-1, 9.75623159e-1,
  9.77483377e-1, 9.79271407e-1, 9.80986977e-1, 9.82629829e-1, 9.84199713e-1,
  9.85696393e-1, 9.87119643e-1, 9.88469246e-1, 9.89745e-1, 9.90946711e-1,
  9.92074198e-1, 9.9312729e-1, 9.94105827e-1, 9.95009663e-1, 9.9583866e-1,
  9.96592693e-1, 9.97271648e-1, 9.97875422e-1, 9.98403924e-1, 9.98857075e-1,
  9.99234805e-1, 9.99537058e-1, 9.99763787e-1, 9.99914959e-1, 9.99990551e-1,
  9.99990551e-1, 9.99914959e-1, 9.99763787e-1, 9.99537058e-1, 9.99234805e-1,
  9.98857075e-1, 9.98403924e-1, 9.97875422e-1, 9.97271648e-1, 9.96592693e-1,
  9.9583866e-1, 9.95009663e-1, 9.94105827e-1, 9.9312729e-1, 9.92074198e-1,
  9.90946711e-1, 9.89745e-1, 9.88469246e-1, 9.87119643e-1, 9.85696393e-1,
  9.84199713e-1, 9.82629829e-1, 9.80986977e-1, 9.79271407e-1, 9.77483377e-1,
  9.75623159e-1, 9.73691033e-1, 9.71687291e-1, 9.69612237e-1, 9.67466184e-1,
  9.65249456e-1, 9.62962389e-1, 9.60605328e-1, 9.5817863e-1, 9.55682662e-1,
  9.531178e-1, 9.50484434e-1, 9.4778296e-1, 9.45013788e-1, 9.42177336e-1,
  9.39274033e-1, 9.36304317e-1, 9.33268638e-1, 9.30167455e-1, 9.27001237e-1,
  9.23770461e-1, 9.20475618e-1, 9.17117204e-1, 9.13695728e-1, 9.10211707e-1,
  9.06665667e-1, 9.03058145e-1, 8.99389686e-1, 8.95660845e-1, 8.91872186e-1,
  8.88024281e-1, 8.84117711e-1, 8.80153069e-1, 8.76130952e-1, 8.7205197e-1,
  8.67916738e-1, 8.63725883e-1, 8.59480037e-1, 8.55179843e-1, 8.5082595e-1,
  8.46419017e-1, 8.41959711e-1, 8.37448705e-1, 8.32886681e-1, 8.28274329e-1,
  8.23612347e-1, 8.18901439e-1, 8.14142317e-1, 8.09335702e-1, 8.04482319e-1,
  7.99582902e-1, 7.94638193e-1, 7.89648938e-1, 7.84615893e-1, 7.79539817e-1,
  7.74421479e-1, 7.69261652e-1, 7.64061117e-1, 7.58820659e-1, 7.5354107e-1,
  7.4822315e-1, 7.42867702e-1, 7.37475536e-1, 7.32047467e-1, 7.26584315e-1,
  7.21086907e-1, 7.15556073e-1, 7.09992651e-1, 7.0439748e-1, 6.98771407e-1,
  6.93115283e-1, 6.87429962e-1, 6.81716305e-1, 6.75975174e-1, 6.70207439e-1,
  6.6441397e-1, 6.58595644e-1, 6.52753341e-1, 6.46887944e-1, 6.41000339e-1,
  6.35091417e-1, 6.2916207e-1, 6.23213197e-1, 6.17245695e-1, 6.11260467e-1,
  6.05258418e-1, 5.99240456e-1, 5.93207489e-1, 5.87160431e-1, 5.81100196e-1,
  5.75027699e-1, 5.68943859e-1, 5.62849596e-1, 5.56745831e-1, 5.50633486e-1,
  5.44513487e-1, 5.38386758e-1, 5.32254225e-1, 5.26116815e-1, 5.19975458e-1,
  5.1383108e-1, 5.07684611e-1, 5.0153698e-1, 4.95389117e-1, 4.89241951e-1,
  4.83096412e-1, 4.76953428e-1, 4.70813928e-1, 4.64678841e-1, 4.58549094e-1,
  4.52425614e-1, 4.46309327e-1, 4.40201156e-1, 4.34102027e-1, 4.2801286e-1,
  4.21934577e-1, 4.15868096e-1, 4.09814335e-1, 4.03774209e-1, 3.97748631e-1,
  3.91738511e-1, 3.8574476e-1, 3.79768282e-1, 3.73809982e-1, 3.6787076e-1,
  3.61951513e-1, 3.56053138e-1, 3.50176526e-1, 3.44322565e-1, 3.38492141e-1,
  3.32686134e-1, 3.26905422e-1, 3.21150881e-1, 3.15423378e-1, 3.09723782e-1,
  3.04052952e-1, 2.98411747e-1, 2.92801019e-1, 2.87221617e-1, 2.81674384e-1,
  2.76160159e-1, 2.70679775e-1, 2.65234062e-1, 2.59823842e-1, 2.54449933e-1,
  2.49113148e-1, 2.43814294e-1, 2.38554171e-1, 2.33333576e-1, 2.28153297e-1,
  2.23014117e-1, 2.17916814e-1, 2.12862158e-1, 2.07850913e-1, 2.02883837e-1,
  1.97961681e-1, 1.9308519e-1, 1.88255099e-1, 1.8347214e-1, 1.78737036e-1,
  1.74050502e-1, 1.69413247e-1, 1.64825973e-1, 1.60289372e-1, 1.55804131e-1,
  1.51370928e-1, 1.46990432e-1, 1.42663307e-1, 1.38390206e-1, 1.34171776e-1,
  1.30008654e-1, 1.25901469e-1, 1.21850843e-1, 1.17857388e-1, 1.13921708e-1,
  1.10044397e-1, 1.06226043e-1, 1.02467221e-1, 9.87685015e-2, 9.51304424e-2,
  9.1553594e-2, 8.80384971e-2, 8.45856832e-2, 8.11956742e-2, 7.78689827e-2,
  7.46061116e-2, 7.14075543e-2, 6.82737943e-2, 6.52053053e-2, 6.22025514e-2,
  5.92659864e-2, 5.63960544e-2, 5.35931893e-2, 5.08578147e-2, 4.81903443e-2,
  4.55911813e-2, 4.30607187e-2, 4.05993391e-2, 3.82074146e-2, 3.58853068e-2,
  3.36333667e-2, 3.1451935e-2, 2.93413412e-2, 2.73019047e-2, 2.53339336e-2,
  2.34377255e-2, 2.16135671e-2, 1.98617342e-2, 1.81824916e-2, 1.65760932e-2,
  1.50427819e-2, 1.35827895e-2, 1.21963367e-2, 1.08836332e-2, 9.64487731e-3,
  8.48025644e-3, 7.38994662e-3, 6.3741127e-3, 5.43290826e-3, 4.56647559e-3,
  3.77494569e-3, 3.05843822e-3, 2.41706151e-3, 1.85091253e-3, 1.36007687e-3,
  9.44628746e-4, 6.04630957e-4, 3.4013491e-4, 1.51180595e-4, 3.77965773e-5, 0.0,
];
export default {
  props: ["user"],
  created() {
    this.loadGrid();
  },
  components: {
    // Plotly,
  },
  data() {
    return {
      searchID: "",
      latlon: [],
      confirmedEmail: null,
      accountUpdatedAt: null,
      hitNotInGrid: [],
      weekNotInGrid: [],
      currentWeekNotInGrid: [],
      week: 1,
      species: "Tufted Titmouse_tuftit",
      fftLength: 512,
      halfLength: 256,
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
      cn: [
        "Lesser Redpoll_lesred1",
        "Common Redpoll_comred",
        "Hoary Redpoll_hoared",
        "Shikra_shikra1",
        "Cooper's Hawk_coohaw",
        "Northern Goshawk_norgos",
        "Eurasian Sparrowhawk_eurspa1",
        "Sharp-shinned Hawk_shshaw",
        "Common Myna_commyn",
        "Northern Cricket Frog_t-11145339",
        "Southern Cricket Frog_t-11164140",
        "Paddyfield Warbler_padwar1",
        "Great Reed Warbler_grrwar1",
        "African Reed Warbler_afrwar1",
        "Black-browed Reed Warbler_bbrwar1",
        "Blyth's Reed Warbler_blrwar1",
        "Moustached Warbler_mouwar1",
        "Oriental Reed Warbler_orrwar1",
        "Aquatic Warbler_aquwar1",
        "Marsh Warbler_marwar3",
        "Sedge Warbler_sedwar1",
        "Eurasian Reed Warbler_eurwar1",
        "Clamorous Reed Warbler_clrwar1",
        "Common Sandpiper_comsan",
        "Spotted Sandpiper_sposan",
        "Clark's Grebe_clagre",
        "Western Grebe_wesgre",
        "Long-tailed Tit_lottit1",
        "Northern Saw-whet Owl_nswowl",
        "Boreal Owl_borowl",
        "White-throated Swift_whtswi",
        "Whiskered Auklet_whiauk",
        "Red-winged Blackbird_rewbla",
        "Tricolored Blackbird_tribla",
        "Rusty Sparrow_russpa1",
        "Rufous-crowned Sparrow_rucspa",
        "Mandarin Duck_manduc",
        "Wood Duck_wooduc",
        "Eurasian Skylark_skylar",
        "Asian Short-toed Lark_lstlar2",
        "Mediterranean Short-toed Lark_mstlar1",
        "Razorbill_razorb",
        "Common Kingfisher_comkin1",
        "Chukar_chukar",
        "Red-legged Partridge_relpar1",
        "Allard's Ground Cricket_t-11840984",
        "Tinkling Ground Cricket_t-11843287",
        "Walker's Ground Cricket_t-11855914",
        "Egyptian Goose_egygoo",
        "Red Avadavat_redava",
        "White-breasted Waterhen_whbwat1",
        "Buff-bellied Hummingbird_bubhum",
        "White-fronted Parrot_whfpar1",
        "Red-lored Parrot_relpar",
        "Lilac-crowned Parrot_licpar",
        "Yellow-headed Parrot_yehpar",
        "Red-crowned Parrot_recpar",
        "Clicker Round-winged Katydid_t-11838680",
        "Common Virtuoso Katydid_t-11851326",
        "Oblong-winged Katydid_t-11845584",
        "Rattler Round-winged Katydid_t-11854789",
        "Grasshopper Sparrow_graspa",
        "LeConte's Sparrow_lecspa",
        "Nelson's Sparrow_nstspa",
        "Black-throated Sparrow_bktspa",
        "Five-striped Sparrow_fisspa",
        "Northern Pintail_norpin",
        "Green-winged Teal_gnwtea",
        "Mallard_mallar3",
        "American Black Duck_ambduc",
        "Say's Trig_t-11847882",
        "American Toad_t-11140103",
        "Yosemite Toad_t-11050888",
        "Great Plains Toad_t-11100978",
        "Fowler's Toad_t-11132206",
        "Houston Toad_t-11153124",
        "Arizona Toad_t-11160924",
        "Oak Toad_t-11107100",
        "Texas Toad_t-11051816",
        "Southern Toad_t-11045871",
        "Woodhouse's Toad_t-11105570",
        "Anhinga_anhing",
        "Greater White-fronted Goose_gwfgoo",
        "Graylag Goose_gragoo",
        "Pink-footed Goose_pifgoo",
        "Snow Goose_snogoo",
        "Taiga Bean-Goose_taibeg1",
        "Bar-headed Goose_bahgoo",
        "Ross's Goose_rosgoo",
        "Tundra Bean-Goose_tunbeg1",
        "Tawny Pipit_tawpip1",
        "Red-throated Pipit_retpip",
        "Blyth's Pipit_blypip1",
        "Olive-backed Pipit_olbpip",
        "Rock Pipit_rocpip1",
        "Meadow Pipit_meapip1",
        "Richard's Pipit_ricpip1",
        "American Pipit_amepip",
        "Water Pipit_watpip1",
        "Sprague's Pipit_sprpip",
        "Tree Pipit_trepip",
        "Sandhill Crane_sancra",
        "Mexican Whip-poor-will_souwpw1",
        "Chuck-will's-widow_chwwid",
        "Buff-collared Nightjar_bucnig",
        "Eastern Whip-poor-will_easwpw1",
        "California Scrub-Jay_cowscj1",
        "Mexican Jay_mexjay4",
        "Woodhouse's Scrub-Jay_wooscj2",
        "Honey Bee_t-11139707",
        "Little Swift_litswi1",
        "Common Swift_comswi",
        "Alpine Swift_alpswi1",
        "Pallid Swift_palswi3",
        "Golden Eagle_goleag",
        "Military Macaw_milmac",
        "Black-chinned Hummingbird_bkchum",
        "Ruby-throated Hummingbird_rthhum",
        "Great Egret_greegr",
        "Gray Heron_graher1",
        "Great Blue Heron_grbher3",
        "Purple Heron_purher1",
        "Squacco Heron_squher1",
        "Ruddy Turnstone_rudtur",
        "Black Turnstone_blktur",
        "Olive Sparrow_olispa",
        "Bell's Sparrow_belspa2",
        "Sagebrush Sparrow_sagspa1",
        "Thick-billed Warbler_thbwar1",
        "Short-eared Owl_sheowl",
        "Long-eared Owl_loeowl",
        "Burrowing Owl_burowl",
        "Little Owl_litowl1",
        "Protean Shieldback_t-11844441",
        "Rufous-capped Brushfinch_rcbfin1",
        "Verdin_verdin",
        "Redhead_redhea",
        "Ring-necked Duck_rinduc",
        "Common Pochard_compoc",
        "Tufted Duck_tufduc",
        "Black-crested Titmouse_blctit4",
        "Tufted Titmouse_tuftit",
        "Oak Titmouse_oaktit",
        "Juniper Titmouse_juntit1",
        "Bridled Titmouse_britit",
        "Upland Sandpiper_uplsan",
        "Fan-tailed Warbler_fatwar",
        "Rufous-capped Warbler_rucwar",
        "White-eared Hummingbird_whehum",
        "Cedar Waxwing_cedwax",
        "Bohemian Waxwing_bohwax",
        "Ruffed Grouse_rufgro",
        "American Bittern_amebit",
        "Great Bittern_grebit1",
        "Marbled Murrelet_marmur",
        "Brant_brant",
        "Canada Goose_cangoo",
        "Cackling Goose_cacgoo1",
        "Barnacle Goose_bargoo",
        "Hawaiian Goose_hawgoo",
        "Eurasian Eagle-Owl_eueowl1",
        "Great Horned Owl_grhowl",
        "Cattle Egret_categr",
        "Trumpeter Finch_trufin2",
        "Bufflehead_buffle",
        "Common Goldeneye_comgol",
        "Eurasian Thick-knee_eutkne1",
        "Zone-tailed Hawk_zothaw",
        "Short-tailed Hawk_shthaw",
        "Common Buzzard_combuz1",
        "Red-tailed Hawk_rethaw",
        "Red-shouldered Hawk_reshaw",
        "Gray Hawk_gryhaw2",
        "Broad-winged Hawk_brwhaw",
        "Swainson's Hawk_swahaw",
        "Common Black Hawk_comblh1",
        "Great Black Hawk_grbhaw1",
        "Striated Heron_strher",
        "Green Heron_grnher",
        "Lark Bunting_larbun",
        "Greater Short-toed Lark_gstlar1",
        "Lapland Longspur_laplon",
        "Chestnut-collared Longspur_chclon",
        "Smith's Longspur_smilon",
        "Sanderling_sander",
        "Dunlin_dunlin",
        "Baird's Sandpiper_baisan",
        "Red Knot_redkno",
        "Curlew Sandpiper_cursan",
        "White-rumped Sandpiper_whrsan",
        "Stilt Sandpiper_stisan",
        "Purple Sandpiper_pursan",
        "Western Sandpiper_wessan",
        "Pectoral Sandpiper_pecsan",
        "Little Stint_litsti",
        "Least Sandpiper_leasan",
        "Rock Sandpiper_rocsan",
        "Semipalmated Sandpiper_semsan",
        "Temminck's Stint_temsti",
        "Surfbird_surfbi",
        "Siberian Rubythroat_sibrub",
        "California Quail_calqua",
        "Elegant Quail_elequa",
        "Gambel's Quail_gamqua",
        "Scaled Quail_scaqua",
        "Black-throated Magpie-Jay_btmjay",
        "Cory's Shearwater_corshe",
        "Anna's Hummingbird_annhum",
        "Costa's Hummingbird_coshum",
        "Pale-billed Woodpecker_pabwoo1",
        "Northern Beardless-Tyrannulet_nobtyr",
        "Cactus Wren_cacwre",
        "Spotted Wren_spowre1",
        "Spruce Grouse_sprgro",
        "Coyote_t-11031961",
        "Gray Wolf_t-11032766",
        "Eurasian Nightjar_eurnig1",
        "Gray Nightjar_grynig1",
        "Red-necked Nightjar_rennig1",
        "Crested Caracara_y00678",
        "Canada Warbler_canwar",
        "Wilson's Warbler_wlswar",
        "Red Warbler_redwar1",
        "Red-faced Warbler_refwar",
        "Northern Cardinal_norcar",
        "Pyrrhuloxia_pyrrhu",
        "European Goldfinch_eurgol",
        "Citril Finch_citfin1",
        "Common Rosefinch_comros",
        "Long-tailed Rosefinch_lotros1",
        "Orange-billed Nightingale-Thrush_obnthr1",
        "Veery_veery",
        "Hermit Thrush_herthr",
        "Gray-cheeked Thrush_gycthr",
        "Swainson's Thrush_swathr",
        "Canyon Wren_canwre",
        "Red-rumped Swallow_rerswa1",
        "Greater Sage-Grouse_saggro",
        "Baird's Sparrow_baispa",
        "Henslow's Sparrow_henspa",
        "Pigeon Guillemot_piggui",
        "Rufous-tailed Scrub-Robin_rutscr1",
        "Brown Creeper_brncre",
        "Short-toed Treecreeper_shttre1",
        "Eurasian Treecreeper_eurtre1",
        "Pied Kingfisher_piekin1",
        "Cetti's Warbler_cetwar1",
        "Chimney Swift_chiswi",
        "Vaux's Swift_vauswi",
        "Wrentit_wrenti",
        "Kentish Plover_kenplo1",
        "Little Ringed Plover_lirplo",
        "Common Ringed Plover_corplo",
        "Piping Plover_pipplo",
        "Lesser Sand-Plover_lesplo",
        "Eurasian Dotterel_eurdot",
        "Snowy Plover_snoplo5",
        "Semipalmated Plover_semplo",
        "Killdeer_killde",
        "Wilson's Plover_wilplo",
        "Dupont's Lark_duplar1",
        "Whiskered Tern_whiter2",
        "White-winged Tern_whwter",
        "Black Tern_blkter",
        "European Greenfinch_eurgre1",
        "Oriental Greenfinch_origre",
        "Green Kingfisher_grnkin",
        "Elegant Euphonia_eleeup1",
        "Lark Sparrow_larspa",
        "Lesser Nighthawk_lesnig",
        "Common Nighthawk_comnig",
        "Slender-billed Gull_slbgul1",
        "Bonaparte's Gull_bongul",
        "Black-headed Gull_bkhgul",
        "Mottled Owl_motowl",
        "White Stork_whisto1",
        "White-throated Dipper_whtdip1",
        "American Dipper_amedip",
        "Brown Dipper_brodip1",
        "Palestine Sunbird_palsun2",
        "Short-toed Snake-Eagle_shteag1",
        "Eurasian Marsh-Harrier_wemhar1",
        "Northern Harrier_norhar2",
        "Montagu's Harrier_monhar1",
        "Zitting Cisticola_zitcis1",
        "Marsh Wren_marwre",
        "Sedge Wren_sedwre1",
        "Great Spotted Cuckoo_grscuc1",
        "Long-tailed Duck_lotduc",
        "Hawfinch_hawfin",
        "Evening Grosbeak_evegro",
        "Yellow-billed Cuckoo_yebcuc",
        "Black-billed Cuckoo_bkbcuc",
        "Mangrove Cuckoo_mancuc",
        "Northern Flicker_norfli",
        "Gilded Flicker_gilfli",
        "Northern Bobwhite_norbob",
        "Rock Pigeon_rocpig",
        "Stock Dove_stodov1",
        "Common Wood-Pigeon_cowpig1",
        "Inca Dove_incdov",
        "Common Ground Dove_cogdov",
        "Ruddy Ground Dove_rugdov",
        "Short-winged Meadow Katydid_t-11876252",
        "Slender Meadow Katydid_t-11877699",
        "Olive-sided Flycatcher_olsfly",
        "Greater Pewee_grepew",
        "Western Wood-Pewee_wewpew",
        "Eastern Wood-Pewee_eawpew",
        "Indian Roller_indrol2",
        "European Roller_eurrol1",
        "Black Vulture_blkvul",
        "Ruby-crowned Kinglet_ruckin",
        "American Crow_amecro",
        "Northwestern Crow_norcro",
        "Common Raven_comrav",
        "Hooded Crow_hoocro1",
        "Carrion Crow_carcro1",
        "Chihuahuan Raven_chirav",
        "Rook_rook1",
        "Large-billed Crow_labcro1",
        "Eurasian Jackdaw_eurjac",
        "Fish Crow_fiscro",
        "Yellow Rail_yelrai",
        "Common Quail_comqua1",
        "Corn Crake_corcra",
        "Groove-billed Ani_grbani",
        "Common Cuckoo_comcuc",
        "Sunda Cuckoo_suncuc2",
        "Indian Cuckoo_indcuc1",
        "Oriental Cuckoo_oricuc2",
        "Lesser Cuckoo_lescuc1",
        "Himalayan Cuckoo_himcuc1",
        "Greater Whitethroat_grewhi1",
        "Spectacled Warbler_spewar2",
        "Lesser Whitethroat_leswhi4",
        "Western Orphean Warbler_weowar2",
        "Sardinian Warbler_sarwar1",
        "Barred Warbler_barwar1",
        "Dartford Warbler_darwar1",
        "Eurasian Blue Tit_blutit",
        "Azure Tit_azutit2",
        "African Blue Tit_afbtit2",
        "Blue Jay_blujay",
        "Steller's Jay_stejay",
        "Blue Bunting_blubun",
        "Green Jay_grnjay",
        "Iberian Magpie_azwmag3",
        "Azure-winged Magpie_azwmag2",
        "Blue-and-white Flycatcher_bawfly2",
        "Black Swan_blkswa",
        "Trumpeter Swan_truswa",
        "Tundra Swan_tunswa",
        "Whooper Swan_whoswa",
        "Mute Swan_mutswa",
        "Broad-billed Hummingbird_brbhum",
        "Montezuma Quail_monqua",
        "Columbian Trig_t-11839828",
        "Common House-Martin_cohmar1",
        "Sooty Grouse_soogro1",
        "Dusky Grouse_dusgro",
        "White-backed Woodpecker_whbwoo1",
        "Great Spotted Woodpecker_grswoo",
        "Syrian Woodpecker_syrwoo1",
        "Middle Spotted Woodpecker_miswoo1",
        "Black-bellied Whistling-Duck_bbwduc",
        "Fulvous Whistling-Duck_fuwduc",
        "Dog_dogdog",
        "Bobolink_boboli",
        "Iiwi_iiwi",
        "White-headed Woodpecker_whhwoo",
        "Arizona Woodpecker_ariwoo",
        "Red-cockaded Woodpecker_recwoo",
        "Lesser Spotted Woodpecker_leswoo1",
        "Nuttall's Woodpecker_nutwoo",
        "Downy Woodpecker_dowwoo",
        "Ladder-backed Woodpecker_labwoo",
        "Hairy Woodpecker_haiwoo",
        "Lineated Woodpecker_linwoo1",
        "Black Woodpecker_blawoo1",
        "Pileated Woodpecker_pilwoo",
        "Pine Barrens Treefrog_t-11128090",
        "Canyon Treefrog_t-11052284",
        "Bird-voiced Treefrog_t-11146158",
        "Cope's Gray Treefrog_t-11052428",
        "Green Treefrog_t-11043207",
        "Pine Woods Treefrog_t-11149613",
        "Barking Treefrog_t-11109790",
        "Squirrel Treefrog_t-11130854",
        "Gray Treefrog_t-11124704",
        "Gray Catbird_grycat",
        "Little Blue Heron_libher",
        "Little Egret_litegr",
        "Snowy Egret_snoegr",
        "Tricolored Heron_triher",
        "Swallow-tailed Kite_swtkit",
        "Black-winged Kite_bkskit1",
        "White-tailed Kite_whtkit",
        "Greenhouse Frog_t-11149861",
        "Yellow-breasted Bunting_yebbun",
        "Corn Bunting_corbun1",
        "Yellow-browed Bunting_yebbun1",
        "Rock Bunting_rocbun1",
        "Meadow Bunting_meabun1",
        "Cirl Bunting_cirbun1",
        "Yellowhammer_yellow2",
        "Yellow-throated Bunting_yetbun1",
        "Ortolan Bunting_ortbun1",
        "Pine Bunting_pinbun",
        "Black-headed Bunting_blhbun1",
        "Little Bunting_litbun",
        "Rustic Bunting_rusbun",
        "Reed Bunting_reebun",
        "Black-faced Bunting_blfbun1",
        "Pine Flycatcher_pinfly1",
        "Alder Flycatcher_aldfly",
        "Pacific-slope Flycatcher_pasfly",
        "Yellow-bellied Flycatcher_yebfly",
        "Buff-breasted Flycatcher_bubfly",
        "Hammond's Flycatcher_hamfly",
        "Least Flycatcher_leafly",
        "Dusky Flycatcher_dusfly",
        "Cordilleran Flycatcher_corfly",
        "Willow Flycatcher_wilfly",
        "Acadian Flycatcher_acafly",
        "Gray Flycatcher_gryfly",
        "Engine_engine",
        "Environmental_envrnm",
        "Yellow-billed Grosbeak_yebgro1",
        "Japanese Grosbeak_japgro1",
        "Horned Lark_horlar",
        "European Robin_eurrob1",
        "Common Waxbill_comwax",
        "White Ibis_whiibi",
        "Rivoli's Hummingbird_maghum1",
        "Carolina Ground Cricket_t-11849030",
        "Confused Ground Cricket_t-11843278",
        "Indian Silverbill_indsil",
        "Rusty Blackbird_rusbla",
        "Brewer's Blackbird_brebla",
        "Scrub Euphonia_screup1",
        "Eared Quetzal_earque",
        "Dollarbird_dollar1",
        "Merlin_merlin",
        "Aplomado Falcon_aplfal",
        "Lesser Kestrel_leskes1",
        "Peregrine Falcon_perfal",
        "American Kestrel_amekes",
        "Eurasian Hobby_eurhob",
        "Eurasian Kestrel_eurkes",
        "Taiga Flycatcher_taifly1",
        "Collared Flycatcher_colfly1",
        "European Pied Flycatcher_eupfly1",
        "Mugimaki Flycatcher_mugfly",
        "Narcissus Flycatcher_narfly2",
        "Red-breasted Flycatcher_rebfly",
        "Yellow-rumped Flycatcher_korfly1",
        "Fireworks_frwrks",
        "Black Francolin_blkfra",
        "Common Chaffinch_comcha",
        "Brambling_brambl",
        "American Coot_y00475",
        "Eurasian Coot_eurcoo",
        "Northern Fulmar_norful",
        "Crested Lark_crelar2",
        "Thekla's Lark_thelar1",
        "Watercock_waterc1",
        "Wilson's Snipe_wilsni1",
        "Common Snipe_comsni",
        "Great Snipe_gresni1",
        "Eurasian Moorhen_commoo3",
        "Common Gallinule_comgal1",
        "Eurasian Jay_eurjay1",
        "Eastern Narrow-mouthed Toad_t-11138802",
        "Great Plains Narrow-mouthed Toad_t-11130090",
        "Arctic Loon_arcloo",
        "Common Loon_comloo",
        "Red-throated Loon_retloo",
        "Gull-billed Tern_gubter1",
        "Greater Roadrunner_greroa",
        "Kentucky Warbler_kenwar",
        "Mourning Warbler_mouwar",
        "MacGillivray's Warbler_macwar",
        "Common Yellowthroat_comyel",
        "White-tailed Hawk_whthaw",
        "Collared Pratincole_colpra",
        "Ferruginous Pygmy-Owl_fepowl",
        "Northern Pygmy-Owl_nopowl",
        "Eurasian Pygmy-Owl_eupowl1",
        "Common Crane_comcra",
        "Gryllus assimilis_t-11872975",
        "Southern Wood Cricket_t-11847878",
        "Fall Field Cricket_t-11844438",
        "Southeastern Field Cricket_t-11847880",
        "Gun_gungun",
        "Pinyon Jay_pinjay",
        "Yellow-throated Sparrow_chspet1",
        "Eurasian Griffon_eurgri1",
        "Black Oystercatcher_blkoys",
        "Eurasian Oystercatcher_euroys1",
        "American Oystercatcher_ameoys",
        "Cassin's Finch_casfin",
        "House Finch_houfin",
        "Purple Finch_purfin",
        "Ruddy Kingfisher_rudkin1",
        "White-throated Kingfisher_whtkin2",
        "White-tailed Eagle_whteag",
        "Bald Eagle_baleag",
        "Worm-eating Warbler_woewar1",
        "Pallas's Grasshopper Warbler_pagwar1",
        "Booted Eagle_booeag1",
        "Black-winged Stilt_bkwsti",
        "Black-necked Stilt_bknsti",
        "Icterine Warbler_ictwar1",
        "Melodious Warbler_melwar1",
        "Barn Swallow_barswa",
        "Manchurian Bush Warbler_manbuw1",
        "Japanese Bush Warbler_jabwar",
        "Human non-vocal_humnov",
        "Human vocal_humvoc",
        "Human whistle_humwhi",
        "Leach's Storm-Petrel_lcspet",
        "Little Gull_litgul",
        "Caspian Tern_caster1",
        "Pacific Chorus Frog_t-11127057",
        "Wood Thrush_woothr",
        "Brown-eared Bulbul_brebul1",
        "Mediterranean Gull_medgul1",
        "Yellow-breasted Chat_yebcha",
        "Bullock's Oriole_bulori",
        "Hooded Oriole_hooori",
        "Baltimore Oriole_balori",
        "Audubon's Oriole_audori",
        "Scott's Oriole_scoori",
        "Streak-backed Oriole_stbori",
        "Orchard Oriole_orcori",
        "Black-vented Oriole_bkvori",
        "Mississippi Kite_miskit",
        "Booted Warbler_boowar1",
        "Western Olivaceous Warbler_weowar1",
        "Eastern Olivaceous Warbler_eaowar1",
        "Sykes's Warbler_sykwar2",
        "Gulf Coast Toad_t-11145798",
        "Least Bittern_leabit",
        "Little Bittern_litbit1",
        "Yellow Bittern_yelbit",
        "Varied Thrush_varthr",
        "Northern Jacana_norjac",
        "Dark-eyed Junco_daejun",
        "Yellow-eyed Junco_yeejun",
        "Eurasian Wryneck_eurwry",
        "Red-billed Firefinch_rebfir2",
        "Willow Ptarmigan_wilpta",
        "White-tailed Ptarmigan_whtpta1",
        "Rock Ptarmigan_rocpta1",
        "Blue-throated Mountain-gem_buthum",
        "Northern Shrike_norshr4",
        "Bull-headed Shrike_buhshr1",
        "Red-backed Shrike_rebshr1",
        "Brown Shrike_brnshr",
        "Great Gray Shrike_norshr1",
        "Loggerhead Shrike_logshr",
        "Iberian Gray Shrike_ibgshr1",
        "Long-tailed Shrike_lotshr1",
        "Woodchat Shrike_wooshr1",
        "Bay-backed Shrike_babshr1",
        "Herring Gull_hergul",
        "Caspian Gull_casgul2",
        "California Gull_calgul",
        "Common Gull_mewgul",
        "Ring-billed Gull_ribgul",
        "Lesser Black-backed Gull_lbbgul",
        "Glaucous-winged Gull_glwgul",
        "Heermann's Gull_heegul",
        "Glaucous Gull_glagul",
        "Great Black-backed Gull_gbbgul",
        "Yellow-legged Gull_yelgul1",
        "Western Gull_wesgul",
        "Japanese Robin_japrob1",
        "Siberian Blue Robin_sibrob",
        "Rufous-tailed Robin_rutrob1",
        "Black Rail_blkrai",
        "Orange-crowned Warbler_orcwar",
        "Colima Warbler_colwar",
        "Lucy's Warbler_lucwar",
        "Tennessee Warbler_tenwar",
        "Nashville Warbler_naswar",
        "Virginia's Warbler_virwar",
        "Red-billed Leiothrix_reblei",
        "White-striped Woodcreeper_whswoo1",
        "White-tipped Dove_whtdov",
        "Laughing Gull_laugul",
        "Franklin's Gull_fragul",
        "Black Rosy-Finch_bkrfin",
        "Gray-crowned Rosy-Finch_gcrfin",
        "Short-billed Dowitcher_shbdow",
        "Long-billed Dowitcher_lobdow",
        "Swainson's Warbler_swawar",
        "Marbled Godwit_margod",
        "Hudsonian Godwit_hudgod",
        "Bar-tailed Godwit_batgod",
        "Black-tailed Godwit_bktgod",
        "Eurasian Linnet_eurlin1",
        "Twite_twite1",
        "American Bullfrog_t-11113588",
        "Green Frog_t-11154219",
        "Pickerel Frog_t-11148801",
        "Wood Frog_t-11044823",
        "Baikal Bush Warbler_spobuw1",
        "River Warbler_eurwar2",
        "Lanceolated Warbler_lanwar",
        "Savi's Warbler_savwar1",
        "Common Grasshopper-Warbler_cogwar1",
        "Hooded Merganser_hoomer",
        "Crested Tit_cretit2",
        "Red Crossbill_redcro",
        "White-winged Crossbill_whwcro",
        "Parrot Crossbill_parcro2",
        "Wood Lark_woolar1",
        "Thrush Nightingale_thrnig1",
        "Common Nightingale_comnig1",
        "Bluethroat_blueth",
        "Jack Snipe_jacsni",
        "American Wigeon_amewig",
        "Eurasian Wigeon_eurwig",
        "Gadwall_gadwal",
        "Belted Kingfisher_belkin1",
        "Ringed Kingfisher_rinkin1",
        "Eastern Screech-Owl_easowl1",
        "Western Screech-Owl_wesowl1",
        "Whiskered Screech-Owl_whsowl1",
        "Golden-fronted Woodpecker_gofwoo",
        "Red-bellied Woodpecker_rebwoo",
        "Red-headed Woodpecker_rehwoo",
        "Acorn Woodpecker_acowoo",
        "Lewis's Woodpecker_lewwoo",
        "Gila Woodpecker_gilwoo",
        "Black Scoter_blksco2",
        "Common Scoter_blksco1",
        "Calandra Lark_callar1",
        "Blue Mockingbird_blumoc",
        "Wild Turkey_wiltur",
        "Swamp Sparrow_swaspa",
        "Lincoln's Sparrow_linspa",
        "Song Sparrow_sonspa",
        "Abert's Towhee_abetow",
        "California Towhee_caltow",
        "Canyon Towhee_cantow",
        "Rusty-crowned Ground-Sparrow_rcgspa1",
        "Common Merganser_commer",
        "Red-breasted Merganser_rebmer",
        "European Bee-eater_eubeat1",
        "Green Bee-eater_grbeat1",
        "Blue-cheeked Bee-eater_bcbeat1",
        "Elf Owl_elfowl",
        "Greater Angle-wing_t-11874264",
        "Black Kite_blakit1",
        "Red Kite_redkit1",
        "Northern Mockingbird_normoc",
        "Miogryllus saussurei_t-12024862",
        "Tufted Flycatcher_tuffly",
        "Black-and-white Warbler_bawwar",
        "Bronzed Cowbird_brocow",
        "Brown-headed Cowbird_bnhcow",
        "Rufous-tailed Rock-Thrush_rtrthr1",
        "Blue Rock-Thrush_burthr",
        "White-winged Snowfinch_whwsno1",
        "Northern Gannet_norgan",
        "White Wagtail_whiwag",
        "Gray Wagtail_grywag",
        "Citrine Wagtail_citwag",
        "Western Yellow Wagtail_eaywag1",
        "Japanese Wagtail_japwag1",
        "Eastern Yellow Wagtail_eaywag",
        "Asian Brown Flycatcher_asbfly",
        "Gray-streaked Flycatcher_gysfly1",
        "Spotted Flycatcher_spofly1",
        "Brown-backed Solitaire_brbsol1",
        "Townsend's Solitaire_towsol",
        "Wood Stork_woosto",
        "Ash-throated Flycatcher_astfly",
        "Great Crested Flycatcher_grcfly",
        "Nutting's Flycatcher_nutfly",
        "Dusky-capped Flycatcher_ducfly",
        "Brown-crested Flycatcher_bncfly",
        "Slate-throated Redstart_sltred",
        "Painted Redstart_paired",
        "Sulphur-bellied Flycatcher_subfly",
        "Monk Parakeet_monpar",
        "Social Flycatcher_socfly1",
        "Double-crested Cormorant_doccor",
        "Neotropic Cormorant_neocor",
        "False Robust Conehead_t-11878179",
        "Sword-bearing Conehead_t-11871906",
        "Round-tipped Conehead_t-11879189",
        "Robust Conehead_t-11875804",
        "Cuban Ground Cricket_t-11852490",
        "Northern Boobook_norboo1",
        "Noise_nocall",
        "Eurasian Nutcracker_eurnut1",
        "Clark's Nutcracker_clanut",
        "Long-billed Curlew_lobcur",
        "Eurasian Curlew_eurcur",
        "Whimbrel_whimbr",
        "Bristle-thighed Curlew_brtcur",
        "Yellow-crowned Night-Heron_ycnher",
        "Black-crowned Night-Heron_bcnher",
        "Common Pauraque_compau",
        "White-tailed Deer_t-11075702",
        "Fast-calling Tree Cricket_t-11847881",
        "Davis's Tree Cricket_t-11849040",
        "Snowy Tree Cricket_t-11852477",
        "Blackhorned Tree Cricket_t-11843289",
        "Narrow-winged Tree Cricket_t-11854772",
        "Pine Tree Cricket_t-11850166",
        "Four-spotted Tree Cricket_t-11853634",
        "Isabelline Wheatear_isawhe1",
        "Black Wheatear_blawhe1",
        "Northern Wheatear_norwhe",
        "Sooty Tern_sooter1",
        "Connecticut Warbler_conwar",
        "Agile Meadow Katydid_t-11872394",
        "Stripe-faced Meadow Katydid_t-11875824",
        "Handsome Meadow Katydid_t-11874857",
        "Mountain Quail_mouqua",
        "Sage Thrasher_sagthr",
        "Crescent-chested Warbler_crcwar",
        "Black-naped Oriole_blnori1",
        "Eurasian Golden Oriole_eugori2",
        "Striped Sparrow_strspa1",
        "Jumping Bush Cricket_t-11850192",
        "Rufous-bellied Chachalaca_rubcha1",
        "Collared Scops-Owl_cosowl1",
        "Eurasian Scops-Owl_eursco1",
        "Japanese Scops-Owl_jasowl1",
        "Oriental Scops-Owl_orsowl",
        "Ruddy Duck_rudduc",
        "Rose-throated Becard_rotbec",
        "Osprey_osprey",
        "Bearded Reedling_bearee1",
        "Harris's Hawk_hrshaw",
        "Louisiana Waterthrush_louwat",
        "Northern Waterthrush_norwat",
        "Great Tit_gretit1",
        "Japanese Tit_gretit4",
        "Russet Sparrow_russpa2",
        "House Sparrow_houspa",
        "Spanish Sparrow_spaspa1",
        "Italian Sparrow_itaspa1",
        "Eurasian Tree Sparrow_eutspa",
        "Savannah Sparrow_savspa",
        "Fox Sparrow_foxspa",
        "Lazuli Bunting_lazbun",
        "Blue Grosbeak_blugrb1",
        "Painted Bunting_paibun",
        "Indigo Bunting_indbun",
        "Varied Bunting_varbun",
        "Rosy Starling_rossta2",
        "Band-tailed Pigeon_batpig1",
        "Red-billed Pigeon_rebpig1",
        "Gray Partridge_grypar",
        "Ashy Minivet_ashmin1",
        "Coal Tit_coatit2",
        "Canada Jay_gryjay",
        "Siberian Jay_sibjay1",
        "European Honey-buzzard_euhbuz1",
        "Oriental Honey-buzzard_orihob2",
        "Cave Swallow_cavswa",
        "Cliff Swallow_cliswa",
        "Rock Sparrow_rocpet1",
        "Bachman's Sparrow_bacspa",
        "Botteri's Sparrow_botspa",
        "Rufous-winged Sparrow_ruwspa",
        "Cassin's Sparrow_casspa",
        "Olive Warbler_oliwar",
        "Phainopepla_phaino",
        "Great Cormorant_grecor",
        "Common Poorwill_compoo",
        "Red Phalarope_redpha1",
        "Red-necked Phalarope_renpha",
        "Wilson's Phalarope_wilpha",
        "Ring-necked Pheasant_rinphe",
        "Yellow Grosbeak_yelgro",
        "Rose-breasted Grosbeak_robgro",
        "Black-headed Grosbeak_bkhgro",
        "Happy Wren_hapwre1",
        "Laysan Albatross_layalb",
        "Greater Flamingo_grefla3",
        "Daurian Redstart_daured1",
        "Black Redstart_blared1",
        "Common Redstart_comred2",
        "Handsome Trig_t-11850174",
        "Western Bonelli's Warbler_webwar1",
        "Arctic Warbler_arcwar1",
        "Sakhalin Leaf Warbler_salwar1",
        "Common Chiffchaff_comchi1",
        "Eastern Crowned Warbler_eacwar1",
        "Kamchatka Leaf Warbler_arcwar2",
        "Dusky Warbler_duswar",
        "Hume's Warbler_humwar1",
        "Iberian Chiffchaff_ibechi2",
        "Yellow-browed Warbler_yebwar3",
        "Green Warbler_grnwar1",
        "Western Crowned Warbler_weclew1",
        "Eastern Bonelli's Warbler_eabwar1",
        "Two-barred Warbler_grewar2",
        "Pallas's Leaf Warbler_palwar5",
        "Radde's Warbler_radwar1",
        "Wood Warbler_woowar",
        "Mountain Chiffchaff_mouchi2",
        "Pale-legged Leaf Warbler_pllwar1",
        "Greenish Warbler_grewar3",
        "Willow Warbler_wlwwar",
        "Squirrel Cuckoo_squcuc1",
        "Black-billed Magpie_bkbmag1",
        "Eurasian Magpie_eurmag1",
        "Oriental Magpie_orimag1",
        "Black-backed Woodpecker_bkbwoo",
        "American Three-toed Woodpecker_attwoo1",
        "Eurasian Three-toed Woodpecker_ettwoo1",
        "Gray-headed Woodpecker_gyfwoo1",
        "Iberian Green Woodpecker_grnwoo3",
        "Eurasian Green Woodpecker_eugwoo2",
        "Pine Grosbeak_pingro",
        "Green-tailed Towhee_gnttow",
        "Eastern Towhee_eastow",
        "Spotted Towhee_spotow",
        "Flame-colored Tanager_flctan",
        "Hepatic Tanager_heptan",
        "Western Tanager_westan",
        "Scarlet Tanager_scatan",
        "Summer Tanager_sumtan",
        "Great Kiskadee_grekis",
        "Roseate Spoonbill_rosspo1",
        "Snow Bunting_snobun",
        "White-faced Ibis_whfibi",
        "Glossy Ibis_gloibi",
        "European Golden-Plover_eugplo",
        "American Golden-Plover_amgplo",
        "Pacific Golden-Plover_pagplo",
        "Black-bellied Plover_bkbplo",
        "Horned Grebe_horgre",
        "Great Crested Grebe_grcgre1",
        "Red-necked Grebe_rengre",
        "Eared Grebe_eargre",
        "Pied-billed Grebe_pibgre",
        "Black-capped Chickadee_bkcchi",
        "Carolina Chickadee_carchi",
        "Mountain Chickadee_mouchi",
        "Boreal Chickadee_borchi2",
        "Willow Tit_wiltit1",
        "Marsh Tit_martit2",
        "Chestnut-backed Chickadee_chbchi",
        "Mexican Chickadee_mexchi",
        "Blue-gray Gnatcatcher_buggna",
        "Black-tailed Gnatcatcher_bktgna",
        "Black-capped Gnatcatcher_bkcgna",
        "Vesper Sparrow_vesspa",
        "Purple Gallinule_purgal2",
        "Gray-headed Swamphen_purswa3",
        "Western Swamphen_purswa1",
        "Sora_sora",
        "Spotted Crake_spocra1",
        "Power tools_powtoo",
        "Graceful Prinia_grapri1",
        "Purple Martin_purmar",
        "Prothonotary Warbler_prowar",
        "Alpine Accentor_alpacc1",
        "Dunnock_dunnoc1",
        "Bushtit_bushti",
        "Brimley's Chorus Frog_t-11106613",
        "Spotted Chorus Frog_t-11131510",
        "Spring Peeper_t-11049240",
        "Upland Chorus Frog_t-11128923",
        "Southern Chorus Frog_t-11039564",
        "Little Grass Frog_t-11126440",
        "Ornate Chorus Frog_t-11146926",
        "Strecker's Chorus Frog_t-11157653",
        "Striped Chorus Frog_t-11124302",
        "Flammulated Owl_flaowl",
        "Green Parakeet_grnpar",
        "Alexandrine Parakeet_alepar2",
        "Rose-ringed Parakeet_rorpar",
        "Chestnut-bellied Sandgrouse_chbsan",
        "Common True Katydid_t-11876111",
        "Gray Silky-flycatcher_grsfly1",
        "Eurasian Crag-Martin_eurcrm1",
        "Manx Shearwater_manshe",
        "Common Bulbul_combul2",
        "White-eared Bulbul_whebul1",
        "White-spectacled Bulbul_whsbul1",
        "Vermilion Flycatcher_verfly",
        "Yellow-billed Chough_yebcho1",
        "Red-billed Chough_rebcho1",
        "Eurasian Bullfinch_eurbul",
        "Boat-tailed Grackle_botgra",
        "Great-tailed Grackle_grtgra",
        "Common Grackle_comgra",
        "Water Rail_watrai1",
        "Clapper Rail_clarai11",
        "King Rail_kinrai4",
        "Virginia Rail_virrai",
        "Ridgway's Rail_ridrai1",
        "American Avocet_ameavo",
        "Pied Avocet_pieavo1",
        "Common Firecrest_firecr1",
        "Goldcrest_goldcr1",
        "Golden-crowned Kinglet_gockin",
        "Eurasian Penduline-Tit_euptit1",
        "Thick-billed Longspur_mcclon",
        "Bank Swallow_banswa",
        "Black-legged Kittiwake_bklkit",
        "Black Skimmer_blkski",
        "Rock Wren_rocwre",
        "Berylline Hummingbird_berhum",
        "Siberian Stonechat_sibsto1",
        "Whinchat_whinch1",
        "European Stonechat_stonec4",
        "Black Phoebe_blkpho",
        "Eastern Phoebe_easpho",
        "Say's Phoebe_saypho",
        "Couch's Spadefoot_t-11148974",
        "Eastern Gray Squirrel_t-11052840",
        "American Woodcock_amewoo",
        "Eurasian Woodcock_eurwoo",
        "Curve-tailed Bush Katydid_t-11851338",
        "Fork-tailed Bush Katydid_t-11850187",
        "Texas Bush Katydid_t-11853621",
        "Ovenbird_ovenbi1",
        "Calliope Hummingbird_calhum",
        "Broad-tailed Hummingbird_brthum",
        "Rufous Hummingbird_rufhum",
        "Allen's Hummingbird_allhum",
        "European Serin_eurser1",
        "Northern Parula_norpar",
        "Black-throated Blue Warbler_btbwar",
        "Bay-breasted Warbler_babwar",
        "Cerulean Warbler_cerwar",
        "Golden-cheeked Warbler_gchwar",
        "Hooded Warbler_hoowar",
        "Yellow-rumped Warbler_yerwar",
        "Prairie Warbler_prawar",
        "Yellow-throated Warbler_yetwar",
        "Blackburnian Warbler_bkbwar",
        "Grace's Warbler_grawar",
        "Magnolia Warbler_magwar",
        "Black-throated Gray Warbler_btywar",
        "Hermit Warbler_herwar",
        "Palm Warbler_palwar",
        "Chestnut-sided Warbler_chswar",
        "Yellow Warbler_yelwar",
        "Pine Warbler_pinwar",
        "Tropical Parula_tropar",
        "American Redstart_amered",
        "Blackpoll Warbler_bkpwar",
        "Cape May Warbler_camwar",
        "Townsend's Warbler_towwar",
        "Black-throated Green Warbler_btnwar",
        "Mountain Bluebird_moublu",
        "Western Bluebird_wesblu",
        "Eastern Bluebird_easblu",
        "Vinous-throated Parrotbill_vitpar1",
        "Siren_siren1",
        "Red-breasted Nuthatch_rebnut",
        "White-breasted Nuthatch_whbnut",
        "Eurasian Nuthatch_eurnut2",
        "Krüper's Nuthatch_krunut1",
        "Western Rock Nuthatch_rocnut1",
        "Brown-headed Nuthatch_bnhnut",
        "Pygmy Nuthatch_pygnut",
        "Varied Tit_vartit1",
        "Common Eider_comeid",
        "Northern Shoveler_norsho",
        "Cinnamon Teal_cintea",
        "Blue-winged Teal_buwtea",
        "Garganey_gargan",
        "Plains Spadefoot_t-11139213",
        "Red-naped Sapsucker_rensap",
        "Red-breasted Sapsucker_rebsap",
        "Williamson's Sapsucker_wilsap",
        "Yellow-bellied Sapsucker_yebsap",
        "Lawrence's Goldfinch_lawgol",
        "Black-headed Siskin_blhsis1",
        "Pine Siskin_pinsis",
        "Lesser Goldfinch_lesgol",
        "Eurasian Siskin_eursis",
        "American Goldfinch_amegfi",
        "Dickcissel_dickci",
        "Black-chinned Sparrow_bkcspa",
        "Brewer's Sparrow_brespa",
        "Clay-colored Sparrow_clcspa",
        "Chipping Sparrow_chispa",
        "Field Sparrow_fiespa",
        "American Tree Sparrow_amtspa",
        "White-cheeked Starling_whcsta1",
        "Morelet's Seedeater_whcsee1",
        "Cinnamon-rumped Seedeater_whcsee2",
        "Northern Rough-winged Swallow_nrwswa",
        "Long-tailed Jaeger_lotjae",
        "Parasitic Jaeger_parjae",
        "Roseate Tern_roster",
        "Forster's Tern_forter",
        "Common Tern_comter",
        "Arctic Tern_arcter",
        "Little Tern_litter1",
        "Least Tern_leater1",
        "Eurasian Collared-Dove_eucdov",
        "Oriental Turtle-Dove_ortdov",
        "Laughing Dove_laudov1",
        "European Turtle-Dove_eutdov",
        "Tawny Owl_tawowl1",
        "Great Gray Owl_grgowl",
        "Spotted Owl_spoowl",
        "Ural Owl_uraowl1",
        "Barred Owl_brdowl",
        "Eastern Meadowlark_easmea",
        "Western Meadowlark_wesmea",
        "Spotless Starling_sposta1",
        "European Starling_eursta",
        "Northern Hawk Owl_nohowl",
        "Eurasian Blackcap_blackc1",
        "Garden Warbler_garwar1",
        "Subalpine Warbler_subwar1",
        "Least Grebe_leagre",
        "Little Grebe_litgre1",
        "Tree Swallow_treswa",
        "Violet-green Swallow_vigswa",
        "Ruddy Shelduck_rudshe",
        "Common Shelduck_comshe",
        "Eastern Chipmunk_t-11061759",
        "Red Squirrel_t-11056904",
        "Red-flanked Bluetail_refblu",
        "Black-crowned Tchagra_bkctch1",
        "Japanese Paradise-Flycatcher_japfly1",
        "Western Capercaillie_wescap1",
        "Hazel Grouse_hazgro1",
        "Little Bustard_litbus1",
        "Elegant Tern_eleter1",
        "Royal Tern_royter1",
        "Sandwich Tern_santer1",
        "Bewick's Wren_bewwre",
        "Sinaloa Wren_sinwre1",
        "Carolina Wren_carwre",
        "Bare-throated Tiger-Heron_btther1",
        "Masked Tityra_mastit1",
        "Bendire's Thrasher_benthr",
        "Crissal Thrasher_crithr",
        "Curve-billed Thrasher_cubthr",
        "LeConte's Thrasher_lecthr",
        "Long-billed Thrasher_lobthr",
        "California Thrasher_calthr",
        "Brown Thrasher_brnthr",
        "Spotted Redshank_spored",
        "Lesser Yellowlegs_lesyel",
        "Wood Sandpiper_woosan",
        "Wandering Tattler_wantat1",
        "Greater Yellowlegs_greyel",
        "Common Greenshank_comgre",
        "Green Sandpiper_grnsan",
        "Willet_willet1",
        "Solitary Sandpiper_solsan",
        "Marsh Sandpiper_marsan",
        "Common Redshank_comred1",
        "House Wren_houwre",
        "Winter Wren_winwre3",
        "Pacific Wren_pacwre1",
        "Eurasian Wren_winwre4",
        "Elegant Trogon_eletro",
        "Mountain Trogon_moutro1",
        "White-throated Thrush_whtrob1",
        "Black-throated Thrush_datthr1",
        "Japanese Thrush_japthr1",
        "Brown-headed Thrush_brhthr1",
        "Dusky Thrush_dusthr2",
        "Clay-colored Thrush_clcrob",
        "Gray-backed Thrush_gybthr1",
        "Redwing_redwin",
        "Eurasian Blackbird_eurbla",
        "American Robin_amerob",
        "Eyebrowed Thrush_eyethr",
        "Pale Thrush_palthr1",
        "Song Thrush_sonthr1",
        "Fieldfare_fieldf",
        "Rufous-backed Robin_rubrob",
        "Ring Ouzel_rinouz1",
        "Mistle Thrush_misthr1",
        "Greater Prairie-Chicken_grpchi",
        "Sharp-tailed Grouse_shtgro",
        "Couch's Kingbird_coukin",
        "Thick-billed Kingbird_thbkin",
        "Scissor-tailed Flycatcher_sctfly",
        "Tropical Kingbird_trokin",
        "Eastern Kingbird_easkin",
        "Western Kingbird_weskin",
        "Cassin's Kingbird_caskin",
        "Barn Owl_brnowl",
        "Eurasian Hoopoe_hoopoe",
        "Common Murre_commur",
        "Asian Stubtail_asistu1",
        "Red-wattled Lapwing_rewlap1",
        "Spur-winged Lapwing_spwlap1",
        "Northern Lapwing_norlap",
        "Golden-winged Warbler_gowwar",
        "Blue-winged Warbler_buwwar",
        "Black-capped Vireo_bkcvir1",
        "Bell's Vireo_belvir",
        "Cassin's Vireo_casvir",
        "Yellow-throated Vireo_yetvir",
        "Yellow-green Vireo_yegvir",
        "Warbling Vireo_warvir",
        "White-eyed Vireo_whevir",
        "Hutton's Vireo_hutvir",
        "Golden Vireo_golvir1",
        "Red-eyed Vireo_reevir1",
        "Philadelphia Vireo_phivir",
        "Plumbeous Vireo_plsvir",
        "Blue-headed Vireo_buhvir",
        "Gray Vireo_gryvir",
        "Blue-black Grassquit_blbgra1",
        "Yellow-headed Blackbird_yehbla",
        "Terek Sandpiper_tersan",
        "Ivory-billed Woodcreeper_ivbwoo1",
        "Gray-capped Pygmy Woodpecker_gycwoo1",
        "Ruddy-breasted Crake_rubcra1",
        "Little Crake_litcra1",
        "Baillon's Crake_baicra1",
        "White-winged Dove_whwdov",
        "Mourning Dove_moudov",
        "White-throated Sparrow_whtspa",
        "Golden-crowned Sparrow_gocspa",
        "White-crowned Sparrow_whcspa",
        "Harris's Sparrow_harspa",
        "White's Thrush_scathr2",
        "Nanday Parakeet_bkhpar",
      ],
      urlStates:
        "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
      attributionSummary:
        "Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC",
    };
  },
  watch: {},
  methods: {
    async getWeek(yyyymmdd) {
      var w = moment(yyyymmdd, "YYYY-MM-DD").week();
      var eBirdWeek = Math.floor((48.0 * w) / 52.0);
      if (eBirdWeek > 48) eBirdWeek = 48;
      if (eBirdWeek == 0) eBirdWeek = 1;
      // console.log(eBirdWeek);
      return eBirdWeek;
    },
    isBat(itemOrSpCode) {
      if (typeof itemOrSpCode === 'object' && itemOrSpCode !== null) {
        return itemOrSpCode.group === 'bat';
      }
      return itemOrSpCode === 'batbatbat';
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      const itemWithApostrophe = itemWithUnderscores.replace(/'/g, "");
      // // console.log("link", itemWithUnderscores);
      return itemWithApostrophe;
    },
    async loadGrid() {
      var cnSpCode = this.species.split("_");
      var searchID = cnSpCode[1] + "_" + this.week;
      // console.log(searchID);
      const grid = await API.graphql({
        query: getGridBySpCode,
        variables: { id: searchID },
      });
      var gridBySpecies = grid.data.getGridBySpCode;
      // console.log(gridBySpecies);
      this.gridBySpecies = gridBySpecies;
      this.latlon = [];
      for (var i = 0; i < gridBySpecies.lat.length; i++) {
        this.searchID = searchID; // update if successful
        this.latlon.push({
          lat: gridBySpecies.lat[i],
          lon: gridBySpecies.lon[i],
          id: 'latlon' + i
        });
      }
      this.currentWeekNotInGrid = this.weekNotInGrid[this.week];
      // console.log(this.currentWeekNotInGrid);
      // if (changeSpecies) this.loadHitNotInGrid(cnSpCode[1]);
    },
    async loadHitNotInGrid(spCode) {
      var serialList = [];
      this.hitNotInGrid = [];
      var nextToken = null;
      var hitNotInGridList = [];
      do {
        const hitNotInGridObj = await API.graphql({
          query: hitNotInGridBySpeciesByDate,
          variables: {
            spCode: spCode,
            dt: { gt: "2022-01-01" },
            nextToken: nextToken,
          },
        });
        hitNotInGridList = hitNotInGridList.concat(
          hitNotInGridObj.data.hitNotInGridBySpeciesByDate.items
        );
        nextToken = hitNotInGridObj.data.hitNotInGridBySpeciesByDate.nextToken;
      } while (nextToken != null);

      // console.log(hitNotInGridList);
      // organize by serial
      var counter = 0;
      var hitNotInGridDict = {}; // lookup for serial position
      this.weekNotInGrid = [];
      // initialize array for objects
      for (var i = 0; i < 49; i++) {
        this.weekNotInGrid.push([]);
      }
      for (const item of hitNotInGridList) {
        // console.log(item);
        var w = moment(item["dt"].substr(0, 10), "YYYY-MM-DD").week();
        var eBirdWeek = Math.floor((48.0 * w) / 52.0);
        if (eBirdWeek > 48) eBirdWeek = 48;
        if (eBirdWeek == 0) eBirdWeek = 1;
        this.weekNotInGrid[eBirdWeek].push([
          { latitude: item["latitude"], longitude: item["longitude"] },
        ]);
        if (!serialList.includes(item.serial)) {
          serialList.push(item.serial);
          hitNotInGridDict[item.serial] = counter;
          this.hitNotInGrid.push(item);
          this.hitNotInGrid[counter].id = 'hng' + counter;
          this.hitNotInGrid[counter].id2 = 'hngid2_' + counter;
          this.hitNotInGrid[counter].wavList = [
            {
              filename: item["wav"],
              listname: item["dt"] + ' ' + item["score"],
              score: item["score"],
              week: eBirdWeek,
            },
          ];
          this.hitNotInGrid[counter].currentWav = {
            filename: item["wav"],
            listname: item["dt"] + ' ' + item["score"],
            score: item["score"],
            week: eBirdWeek,
          };
          counter = counter + 1;
        } else {
          this.hitNotInGrid[hitNotInGridDict[item.serial]]["wavList"].push({
            filename: item["wav"],
            listname: item["dt"] + ' ' + item["score"],
            score: item["score"],
            week: eBirdWeek,
          });
        }
      }
      // console.log(this.hitNotInGrid);
      // console.log(this.weekNotInGrid);
    },
    spectrogram(index, audioFile) {
      async function getFile(audioContext, filepath) {
        // standardized-audio-context from npm
        const nativeAudioContext = new AudioContext();
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          nativeAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        var context = new AudioContext();
        const sample = await getFile(context, filePath);
        return sample;
      }

      function linear2Decibel(value) {
        var dB = 20 * Math.log10(value);
        return dB;
      }

      //var c = document.getElementById("myCanvas");
      //this.canvas = c.getContext("2d");

      Storage.get(audioFile)
        .then(
          (result) => {
            // console.log("Storage get", result);

            setupSample(result)
              .then((sample) => {
                // console.log("sample", sample);
                let signal = sample.getChannelData(0);
                // console.log("raw", signal);

                // calculate spectrogram
                // let ts = 0;

                let overlap = 0.0;
                let fftLength = this.fftLength;
                let halfLength = this.halfLength; // chop off top

                let showLength = halfLength - Math.round(0.2 * halfLength);
                let zmidVal = -90;
                if (audioFile[5] == "2") {
                  showLength = halfLength - Math.round(0.48 * halfLength);
                  zmidVal = -66;
                }

                let offset = Math.floor(fftLength * (1.0 - overlap));
                // console.log("offset", offset);
                // let ctx = this.canvas;
                let fft = new FFT(fftLength, 44100);

                var spectrogramArray = [];
                for (var x = 0; x < sample.length - fftLength; x += offset) {
                  var chunk = signal.slice(x, x + fftLength);
                  for (var i = 0; i < fftLength; i++) {
                    chunk[i] = chunk[i] * hann[i];
                  }
                  fft.forward(chunk);
                  chunk = fft.spectrum.slice(0, showLength);
                  // console.log("fft", chunk);
                  var dBmag = chunk.map(linear2Decibel);
                  // console.log("dB", dBmag);
                  spectrogramArray.push(...dBmag);
                }

                // console.log("spectrogramArray", spectrogramArray);
                // console.log('showLength', showLength);

                // arrange spectrogram for Plotly
                var spectrogramData = [];
                for (i = 0; i < showLength; i++) {
                  // grab one element every halfLength points
                  var arr = spectrogramArray.filter(function (value, j) {
                    return j % showLength == 0;
                  });
                  // console.log(arr);
                  spectrogramData.push(arr);
                  spectrogramArray.shift(); // remove first element
                }
                // console.log("spectrogramData", spectrogramData);

                this.hitNotInGrid[index].spectrogram = [
                  {
                    z: spectrogramData,
                    type: "heatmap",
                    showscale: false,
                    zmid: zmidVal,
                  },
                ];
                // console.log('spec done', this.hitNotInGrid[index]);
                this.hitNotInGrid[index].id = this.hitNotInGrid[index].id + "1";
              })
              .catch((err) => {
                console.log(err);
                console.log("No audio", audioFile);
                // console.log("Delete index", index);
                this.snackbar = true;
                return false;
              });
          },
          (reason) => {
            // rejection
            console.log("Can't play ", reason);
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },
    async playFile(audioFile, spCode, cn, item, index, resetLabel) {
      // console.log('playFile', resetLabel);
      if (resetLabel === true) {
        item.classLabel = null;
      }
      // console.log("playFile", audioFile);

      var audio = new Audio();
      var context = new AudioContext();
      var source = context.createMediaElementSource(audio);
      var filter = context.createBiquadFilter();
      source.connect(filter);
      filter.connect(context.destination);
      filter.type = "highshelf";
      filter.frequency.value = 400;
      filter.gain.value = 40;
      if (cn.includes("Great Horned Owl")) {
        //console.log("GHO playback");
        filter.type = "highshelf";
        filter.frequency.value = 100;
        filter.gain.value = 40;
      }
      if (cn.includes("Barred Owl")) {
        //console.log("GHO playback");
        filter.type = "highshelf";
        filter.frequency.value = 200;
        filter.gain.value = 40;
      }

      audio.crossOrigin = "anonymous";
      audio.autoplay = true;

      if (context.state === "suspended") {
        context.resume();
      }

      // check to see if s3 file exists...takes too long
      await Storage.list(audioFile)
        .then((result) => {
          if (result.length > 0) {
            Storage.get(audioFile)
              .then((result) => {
                filter.gain.value = 30;
                audio.src = result;
                audio.play();
              })
              .catch((err) => {
                console.log(err);
                console.log("No audio", audioFile);
                // console.log("Delete index", index);
                this.snackbar = true;
                return false;
              });
          } else {
            this.snackbar = true;
          }
        })
        .catch((err) => console.log(err));

      this.spectrogram(index, item.currentWav["filename"]);
      item.classLabel = null;
    },
  },
};
</script>
  